// zh.js
export default {
  // 可以以页面为单位来写，比如首页的内容，写在index字段，个人中心写在center，公共部分写在common部分
  lang: {
    title: 'Interfaz de usuario uView',
    intro: '多平台快速开发的UI框架'
  },
  loain: {
    _Inscreverse: 'Inscripción',
    _AcessoDeMembro: 'Inicio de sesión'
  },
  _buome: {
    _Retornar: 'Devolución',
    _Salvar: 'Guardar'
  },

  _placeholder: {
    _Introduza: 'Introduce tu ID de WeChat',
    _IntroduzaMessage:
      'El ID de WeChat debe empezar por una letra o un guión bajo y tener entre 6 y 20 letras, números, guiones bajos y/o guiones.',
    _WhatsApp: 'Introduce tu ID de WhatsApp',
    _WhatsAppMessage: 'Introduzca 6-40 números',
    _Facebook: 'Introduce tu ID de Facebook',
    _FacebookMessage:
      'Por favor, introduzca 3-50 bits de inglés/números/caracteres',
    _telegram: 'Introduzca el ID del telegrama',
    _telegramMessage: 'Introduzca 5-40 letras/números/alfabetos',
    _Selecione:
      'Seleccione su fecha de nacimiento (una vez establecida, no se puede cambiar)',
    _PorFavorSenha: 'Introduzca la nueva contraseña',
    _Outros: 'Otros métodos de verificación',
    _ConfirmarNovoSenha: 'Confirmar nueva contraseña',
    _TodasPlataformas: 'Todas las plataformas',
    _DetalhesdaSubcategoria: 'Detalles de la subcategoría',
    _Inserirnomedeusurio: 'Nombre de usuario',
    _Introduzapalavrapasse: 'Introduzca su contraseña'
  },
  menGMen: {
    _NomedeUsuário: 'Nombre de usuario',
    _Desvincular: 'Desata',
    _deTelefone: 'Teléfono',
    _EndereMail: 'Dirección de correo electrónico',
    _GoogleAuthenticator: 'Autenticador de Google',
    _SenhadeLogin: 'Contraseña',
    _SenhadeSaque: 'Contraseña de retirada',
    _FoiDefinido: 'Se ha definido',
    _NConfigurado: 'No configurado',
    _Perguntade: 'Cuestión de seguridad',
    _Deletartudo: 'Borrar todo',
    _Apostas: 'Apuestas',
    _Valor: 'Valor',
    _Ganhos: 'Ganancias',
    _Semdadosdispo: 'No hay datos disponibles',
    _Informapromo: 'Información sobre la promoción',
    _Subordinados: 'Dirigir a los subordinados',
    _Convite_me: 'Código de invitación',
    _Subordinadoslidos: 'Subordinados válidos',
    _pessoas: 'gente',
    _Detalhes: 'Detalles',
    _queCumprir:
      'qué es un número promocional válido? (cumplir todos los requisitos enumerados a continuación)',
    _subordinadoMens: 'Depósitos acumulados del subordinado',
    _ouMais: 'o más',
    _ApostasSubordinado: 'Apuestas acumuladas del subordinado'
  },
  _Nenhumjogodisponvel: 'No hay juegos disponibles',
  _Misto: 'Mixto',

  _home: {
    _Popularjogos: ' Juegos',
    _Aexibir: ' Mostrar ',
    _jogosentre: 'partidos entre',
    _Carregarmais: 'Más información',
    _Eventos: 'Eventos',
    _Missão: 'Misión',
    _Rebate: 'Rebaja',
    _Pendente: 'Pendiente',
    _VIP: 'VIP',
    _Sorteio: 'Sorteo',
    _Checkin: 'Check in',
    _Convidar: 'Agente',
    _Compartilhar: 'Compartir',
    _FundodePrevidência: 'Fondo de previsión',
    _Surpresa: 'Sorpresa',
    _Slots: 'Tragamonedas',
    _Pescaria: 'Pesca',
    _Demo: 'Demo',
    _Todos: 'Todo',
    _Mais: 'Más',
    _Suporteonline: 'Asistencia en línea',
    _CentraldeAjuda: 'Centro de ayuda',
    _BônusdeSugestão: 'Bonificación por sugerencias',
    _Segurança: 'Seguridad',
    _Cassino: 'Casino',
    _Jogos: 'Juegos',
    _Suporte: 'Ayuda',
    _LicenseCompliance: 'Cumplimiento de la licencia',
    _Contatenos: 'Póngase en contacto con nosotros',
    _CanalOficial: 'Canal Oficial',
    _tis: 'El juego está en mantenimiento',
    _balanceLess1: 'Su saldo es menor a C$',
    _balanceLess2: ', Por favor\r\nhaz un depósito para jugar',
    _rechargeLess1:
      'Su cuenta no está activada Realice un depósito de cualquier monto para activar su cuenta y comenzar a jugar.',
    _rechargeLess2: 'Su depósito es menor a C$',
    _rechargeLess3: ', Por favor\r\nhaz un depósito para jugar',
    _Válidos: 'Válido',
    _Válido: 'Válido',
    _Inválido: 'No válido',
    _Taxade: 'Tasa de',
    _ReceberTudo: 'Recibir todo',
    _Podeserresgatadohoje: 'Puede canjearse hoy',
    _CASSINO: 'CASSINO',
    _entertainment:
      'es un sitio web de entretenimiento en línea que ofrece a sus usuarios una experiencia única de apuestas deportivas. Este sitio web está gestionado por',
    _NovaWave: 'NovaWave Technology N.V.',
    _Caribbeaundern:
      'una empresa registrada en Curaçao, con el número 162293, con domicilio social en Schottegatweg Oost 10, Unit 1-9, Bon Bini Business Center, Willemstad, Curaçao, Caribe neerlandés, una entidad debidamente autorizada y autorizada por el Gobierno de Curaçao.',
    _accessingBy:
      'Al acceder a este sitio web, continuar utilizándolo o navegar por él, acepta que utilicemos determinadas cookies del navegador para mejorar su experiencia mientras utiliza nuestro sitio. Sólo utilizamos cookies para mejorar su experiencia, y esto no interfiere con su privacidad',
    _Distnciaw: 'Distancia',
    _Convideumpacote:
      'Invita a un amigo a abrir un paquete de bonificación rojo',
    _Recebido: 'Recibido',
    _Montantefixo: 'Cantidad a tanto alzado',
    _jogador: 'Jugador',
    _payout: 'Pago',
    _Mais: 'Más',
    _Saques: 'Retiros',
    _Blockchain: 'Blockchain',
    _DownloadAPPMoreDiscounts:
      'Descarga la APP para participar en más descuentos!',
    _BaixarAgora: 'Descargar ahora',
    _Pesquisar: 'Buscar en',
    _BaixeeuseoAPP: 'Descargar y utilizar la APP',
    _BaixeoAPP: 'Descargar la APP',
    _aproveitarmaisdescontos: 'disfruta de más descuentos'
  },

  _VIP: {
    _Lembrete: 'Recordatorio',
    _LembreteConter:
      'Para pasar al siguiente nivel, es necesario realizar apuestas adicionales al total de apuestas válidas acumuladas. Por ejemplo: si el requisito de apuestas válidas para avanzar a VIP1 es 1000, y el requisito para avanzar a VIP2 es 2000, entonces el socio necesita acumular un total de 1000 + 2000 = 3000 apuestas válidas para avanzar a VIP2, y así sucesivamente.',
    _LembreteConterDeposit:
      'Para ascender al siguiente nivel, los miembros deben alcanzar un depósito acumulado. Por ejemplo, si el requisito de depósito para ascender a VIP1 es de 30 y el requisito de depósito para ascender a VIP2 es de 300, entonces el depósito acumulado de 300 de un miembro puede ascender a VIP2, y así sucesivamente.',
    _NívelAtual: 'Nivel actual',
    _Restantes: 'Resto',
    _Apostemais: 'Apostar más',
    _DepositMore: 'Deposite más',
    _ResgatarTudo: 'Rescatar todo',
    _Histórico: 'Historia',
    _ListadeníveisVIP: 'Lista de niveles VIP',
    _InstruçõessobreregrasVIP: 'Instrucciones sobre las normas VIP',
    _Nível: 'Nivel',
    _Apostaparapromoção: 'Apostar por el ascenso',
    _DepositPromotion: 'Depósito para promoción',
    _BônusDeAumentoDe: 'Aumentar la bonificación ',
    _Bônus: 'Bono',
    _Ovalortotaldaretiradadiária: 'Número de retiros por día',
    _Olimitesuperiordaretiradadiária: 'El límite máximo de retirada diaria',
    _Taxasdeisençãodiáriacaneta: 'Tarifas diarias de exención de bolígrafo',
    _NumberOfWithdrawals: 'Número de retiros',
    _WithdrawalLimit: 'Límite de retiro',
    _PenExemptionFees: 'Tarifas de exención de bolígrafo',
    _Totaldedepósitos: 'Depósitos totales',
    _FundodePrevidência: 'Fondo de previsión',
    _Depósito: 'Depósito',
    _Retira: 'Retirar',
    _Nãosertapado: 'No te tapes',
    _BônusMáximoNãosertapado: 'Bonificación máxima',
    _LimiteMáximoNãosertapado: 'Límite máximo',
    _acumulaçãototal0: 'acumulación total',
    _Horário: 'Horario',
    _Taxadebônus: 'Tasa de bonificación',
    _Taxadebônus: 'Tasa de bonificación',
    _Númerodeapostas: 'Número de apuestas',
    _Novosrequerimentosparaaposta: 'Nuevos requisitos para las apuestas',
    _Vocêprecisaapostar: 'Tienes que apostar',
    _presenteMeLOfgn: 'Método de regalo',
    _recarregar:
      'Cada vez que recargue, recibirá una bonificación por valor del 100% de la recarga. La bonificación se ingresa en la cuenta del fondo de previsión. Cuantas más recargas hagas, más bonificaciones recibirás.',
    _Condies: 'Condiciones',
    _Cadaprevid:
      'Cada vez que recargue, se acumulará un nuevo fondo de previsión, por lo que deberá completar apuestas efectivas 35 veces el importe principal de la recarga cada vez antes de poder retirar el fondo de previsión; si el fondo de previsión no se da o se ha limitado, deberá completar apuestas efectivas 5 veces la recarga.',
    _BnusMximo: 'Bonificación máxima',
    _gratuitos:
      'Durante el ciclo de actividad,Número de regalos gratuitos,No hay límite a la cantidad acumulada en el CPF.',
    _Redefinirciclo: 'Ciclo de reinicio',
    _retiradoMense_mes:
      'El periodo de validez del fondo de previsión es de 1Por mes，Si no se retira 31 días después del final del ciclo，La recompensa del fondo de previsión no será válida y el fondo de previsión sólo se puede recibir una vez por ciclo.',
    _Auditoriamltipla: 'Auditorías múltiples',
    _fundoRetirado:
      'La bonificación de fondo de reserva retirada requiere 15 veces de apuesta efectiva antes de solicitar la retirada, con apuestas limitadas a la Plataforma de Juego Ilimitado.',
    _Recebarestries: 'Recibir restricciones',
    _apenasAndroid:
      'Solo disponible para canje manual en PC、H5、Android-APP、iOS-APP.',
    _Violadasregras: 'Romper las reglas',
    _meSomente:
      'Sólo el propietario de la cuenta puede realizar operaciones humanas normales. Está prohibido alquilar, utilizar plug-ins, robots, jugar con diferentes cuentas, cepillarse mutuamente, arbitraje, interfaces, protocolos, explotar lagunas, control de grupo u otros medios técnicos. De lo contrario, se cancelará la participación o se deducirán las recompensas, se congelarán o incluso se incluirán en una lista negra.',
    _Aexplicainal: 'La explicación final',
    _Paraevitar:
      'Para evitar diferencias en la comprensión del texto, la plataforma se reserva el derecho a la interpretación final de este evento.',
    _des_1:
      'Norma de promoción: si cumple los requisitos de la promoción VIP (es decir, si la recarga o las apuestas efectivas cumplen las condiciones), podrá ascender al nivel VIP correspondiente y obtener la bonificación de promoción correspondiente;',
    _des_2:
      'Salario diario: Si la recarga diaria y las apuestas válidas cumplen los requisitos de salario diario del nivel actual, podrás obtener la bonificación de salario diario correspondiente. Si avanzas a varios niveles consecutivos, solo podrás obtener la bonificación de salario diario del nivel actual.La bonificación se puede recibir de vez en cuando;',
    _des_3:
      'Salario semanal: Si la recarga semanal y las apuestas válidas cumplen los requisitos del nivel actual de salario semanal, podrá obtener la bonificación de salario semanal correspondiente. Si se avanza a varios niveles consecutivos, solo se puede obtener el nivel actual de bonificación salarial semanal.La bonificación se puede recibir de vez en cuando;',
    _des_4:
      'Lulu mensual: haga una recarga mensual y apueste de forma efectiva para alcanzar el nivel mensual de Lulu actual, y podrá obtener la bonificación de premio mensual correspondiente.La bonificación se puede recibir de vez en cuando;',
    _des_5:
      'Caducidad de la bonificación: La bonificación recibida estará disponible durante %d días. Si no se canjea activamente durante este periodo, se abonará automáticamente en la cuenta. Por ejemplo: si se obtiene una recompensa el 1 de enero y se conserva durante %d días, se abonará automáticamente en la cuenta el %d de enero a las 00:00:00.',
    _des_6:
      'Instrucciones de auditoría: la bonificación VIP ofrecida sólo puede retirarse una vez cumplido el requisito de rollover 1x (es decir, auditoría, apuestas o apuestas válidas), independientemente de la plataforma en la que juegue;',
    _des_7:
      'Declaraciones: Esta función se limita a las operaciones normales de los titulares de cuentas. Está prohibido alquilar cuentas, realizar apuestas sin riesgo (apuestas con diferentes cuentas, swiping mutuo y swiping de cuotas bajas), arbitraje vicioso, utilizar plug-ins, robots, explotar acuerdos, lagunas, interfaces, control de grupo u otros medios técnicos de participación; de lo contrario, una vez demostrado, la plataforma tiene derecho a prohibir a los miembros el inicio de sesión, suspender su uso de nuestro sitio web y confiscar la bonificación y las ganancias indebidas, sin ninguna advertencia especial;',
    _des_8:
      'Instrucciones: Al reclamar el bono VIP, se considera que los miembros aceptan y cumplen las normas correspondientes. Para evitar diferencias en la comprensión del texto, la plataforma se reserva el derecho final a interpretar esta actividad. '
  },

  yuebao: {
    _Apostado: 'Apuesta',
    _Introduaosganhos: 'Introducción a los beneficios',
    _mens_depositado:
      'La cantidad depositada en la tesorería de intereses debe cumplir un ciclo completo para generar intereses. Si se retira antes, el ciclo no contará para los beneficios. Por ejemplo, si el periodo de liquidación actual es de 1 hora, el importe transferido el 2023-01-01 00:00:01 generará el primer ciclo de intereses el 2023-01-01 01:00:01;',
    _CiclodeLiquida: 'Ciclo de liquidación',
    _horasatualde:
      'El periodo actual de liquidación de intereses es de 1 hora;',
    _Taxadejurosanual: 'Tipo de interés anual',
    _menNemsn: ' El tipo de interés anual actual es del 100%;',
    _Frmuladelculo: 'Fórmula de cálculo',
    _LucroDos:
      'Beneficio por intereses = importe del depósito * tipo de interés anual / periodo de liquidación;',
    _Exemplo: 'Ejemplo',
    _Umem_anual:
      'Un depósito de 10.000 el 01/01/2023 a las 00:00:01, con un tipo de interés anual del 100 por cien y un periodo de liquidación de 1 hora, tiene su primer rendimiento de intereses el 2023-01-01 01:00:01. El cálculo es el siguiente',
    _PrimeiroMensDejuros:
      'Rendimiento del primer interés = 10.000*100%/365 días/24 horas*1 hora = 1,141552',
    _Limiardeentrada: 'Umbral de entrada',
    _Limitedejuros: 'Límite de interés',
    _ltiplodeauditoria: 'Auditoría múltiple',
    _Declaradoevento: 'Declaración del acontecimiento',
    _Explica: 'Explicación',
    _valorCadaIgual:
      'El importe de cada transferencia debe ser mayor o igual a 50 (es decir, ≥ 50), sin límite superior en el importe de la transferencia. Cuanto más transfieras, mayor será el beneficio;',
    _taxaDeIurosAtual:
      'No hay límite para el tipo de interés vigente. Recuerda cobrar el alquiler con regularidad o frecuencia para evitar perder más ingresos;',
    _Depositado: 'Depositado',
    _Tempodereivindica: 'Tiempo de reclamación',
    _resgatarPode:
      'Puede rescatar al día siguiente, lo que significa que los intereses generados el mismo día pueden reclamarse después de las 00:00 del día siguiente.',
    _ensbeConemauditoria:
      'El múltiplo de auditoría actual es de 30 veces (requisito de volumen de apuestas). Esto significa que los intereses recibidos deben apostarse antes de retirarlos. Solo es necesario auditar los intereses recibidos, mientras que el importe principal transferido no requiere auditoría;',
    _Estalimitada:
      'Esta función se limita a la cuenta. Se prohíbe el alquiler de cuentas, las apuestas sin riesgo (de juego, emparejamiento, baja compensación, cepillado de agua), el arbitraje malicioso, el uso de procesos plug -in, robots, acuerdos de uso de robots, vulnerabilidades, interfaces,Control de grupo u otros medios técnicos están prohibidos. Una vez verificado, la plataforma se reserva el derecho de cancelar el inicio de sesión de los miembros, suspender el uso del sitio por parte de los miembros y confiscar las bonificaciones y los beneficios indebidos sin previo aviso;',
    _Ciclodeassentamento1horas: 'Ciclo de asentamiento\n1 hora',
    _Coleçãocumulativa: 'Recogida acumulada',
    _QuandoNmmembro:
      'Cuando un miembro reciba la recompensa Yibao, la plataforma asumirá que el miembro acepta y cumple las condiciones correspondientes y otras regulaciones relevantes. Para evitar ambigüedades en la comprensión del texto, la plataforma se reserva el derecho final de interpretar este hecho;',
    _MáximodejurosIlimitado: 'Interés máximo ilimitado',
    _TaxadeJurosAnual100: 'Tipo de interés anual 100,00',
    _Depósito: 'Depósito',
    _Transferir: 'Descargar',
    _Receber: 'Reciba',
    _Horas: 'Horas',
    _Tipos: 'Tipos',
    _Quantia: 'Importe',
    _RendaAcumulada0: 'Ingresos acumulados',
    actiVCo: [
      {
        text: 'Hoy',
        value: 0
      },
      {
        text: 'Ayer',
        value: 1
      },
      {
        text: 'Últimos 7 días',
        value: 2
      },
      {
        text: 'Últimos 15 días',
        value: 3
      },
      {
        text: 'Últimos 30 días',
        value: 4
      }
    ],
    actiVCo1: [
      {
        text: 'Todo',
        value: 0
      },
      {
        text: 'Depósito',
        value: 1
      },
      {
        text: 'Descargar',
        value: 2
      },
      {
        text: 'Recibir saldo',
        value: 3
      }
    ]
  },
  description: 'Sin registros',

  toolbar: [
    {
      title: 'Iniciativao'
    },
    {
      title: 'Promocióno'
    },
    {
      title: 'Agentee'
    },
    {
      title: 'Ayudae'
    },
    {
      title: 'Perfill'
    }
  ],
  toolbarConter: {
    _Inicio: 'hogar',
    _Inicio2: 'Inicio',
    _Promoção: 'Promoción',
    _Agente: 'Agente',
    _Suporte: 'Ayuda',
    _Perfil: 'Perfil',
    _Depósito: 'Depósito',
    _Saque: 'Retirada',
    _Login: 'Login',
    _Registro: 'Registro'
  },

  popup: {
    nav: [
      {
        title: 'Popular'
      },
      {
        title: 'Ranuras'
      },
      {
        title: 'Pesca'
      },
      {
        title: 'Demo'
      },
      {
        title: 'Recientese'
      },
      {
        title: 'Favoritoss'
      }
    ],
    nav_31: [
      {
        title: 'Popular'
      },
      {
        title: 'Slots'
      },
      {
        title: 'Blockchain'
      },
      {
        title: 'Pescaria'
      },
      {
        title: 'Demo'
      },
      {
        title: 'Recente'
      },
      {
        title: 'Favorites'
      }
    ],
    _Blockchain: 'Blockchain',
    _parareceber: 'recibir',
    _TaxadeRebate: 'Taxa de Rebate',
    _Recompensas: 'Recompensas',
    _Slots: 'Tragamonedas',
    _Demo: 'Demo',
    _Recente: 'Recientes',
    _Popular: 'Popular',
    _Pescaria: 'Pesca',
    _Blockchain: 'Blockchain',
    _Favoritos: 'Favoritos',
    _Apostas: 'Apuestas',
    _Agente: 'Agente',
    _Promoção: 'Promoción',
    _Eventos: 'Eventos',
    _Histórico: 'Historia',
    _FundodePrevidência: 'Fondo de previsión',
    _Pendente: 'Pendiente',
    _Juros: 'Interés',
    _VIP: 'VIP',
    _Português: 'Portugués',
    _BaixarApp: 'Descargar aplicación',
    _Suporte: 'Ayuda',
    _FAQ: 'PREGUNTAS FRECUENTES',
    _Sobre: 'Acerca de',
    _Aexibir: 'Mostrar',
    _jogosEntre: 'partidos entre',
    _PopularIogos: 'Juegos populares',
    _Carregarmais: 'Más información',
    _BônusDeAumentoDeNível: 'Bonificación por subir de nivel',
    _BônusSemanal: 'Bonificación semanal',
    _BônusMensal: 'Bonificación mensual',
    _PrivilégioVIP: 'Privilegio VIP',
    _Detalhesdoregistro: 'Datos de inscripción',
    _Regrasdejuros: 'Normas sobre intereses',
    _Totalderegistros: 'Registros totales',
    _RequisitosDeapostas: 'Requisitos de las apuestas',
    _Regras: 'Reglas'
  },

  share: {
    _LinkdeConvite: 'Enlace de invitación',
    _MeusDados: 'Mis datos',
    _TodososDados: 'Todos los datos',
    _Desempenho: 'Rendimiento',
    _Comissãopor: 'Comisión de',
    _Comissão: 'Comisión',
    _DadosdoSubordinado: 'Datos del subordinado',
    _ApostasdosSubordinados: 'Apuestas de los subordinados',
    _TaxadeComissão: 'Comisión',
    _CadastrarSubordinados: 'Registrar subordinados'
  },
  notice: {
    _Suporte: 'Ayuda',
    _Notícia: 'Noticias',
    _Notificação: 'Notificación',
    _PainelRolante: 'Panel rodante',
    _BônusdeSugestão: 'Bonificación por sugerencias',
    _TelegramSuporte: 'Soporte Telegram',
    _FacebookSuporte: 'Soporte Facebook',
    _WhatsAppSuporte: 'Soporte WhatsApp',
    _FAQ: 'PREGUNTAS FRECUENTES',
    _PerguntasFreqüentes: 'Preguntas frecuentes',
    _Apoioonline: 'Asistencia en línea',
    _Contactaragora: 'Póngase en contacto con nosotros',
    _Conversecomoserv:
      'Chatee con un servicio profesional de atención al cliente en línea para resolver sus problemas',
    _SemMensagem: 'Ningún mensaje',
    text1: 'Atención al cliente en línea 24',
    text2:
      'Servicio al cliente disponible para ayudar a resolver problemas y responder a dudas presentadas.',
    text3: 'Contacto',
    text4: 'Canal Oficial',
    text5: 'Canal Oficial ®',
    text6: 'Atención al cliente Telegram',
    text7: 'Atención al cliente Whatsapp'
  },
  Recharge: {
    _PaymentMethod: 'Método de pago',
    _Firstdeposit: 'Primer depósito',
    _withBonus: 'Con Bono'
  },
  withdraw: {
    _Solicitarsaque: 'Solicitar una retirada',
    _TarefasdeApostas: 'Tareas de apuestas',
    _Contapararecebimento: 'Cuenta de ingresos',
    _RegistrodeSaques: 'Registro de bajas',
    _Paraasegurança:
      'Por la seguridad de su cuenta, introduzca su contraseña de retirada de fondos',
    _EsqueceuaSenha: 'Ha olvidado su contraseña?',
    _Próximo: 'Siguiente',
    _InserirSenha: 'Introducir contraseña',
    _VerificarSenhadeSaque: 'Verificar contraseña de retirada',
    _DetalhesdeRetiradas: 'Detalles de la retirada',
    _Tipodetransação: 'Tipo de transacción',
    _MétododeRetirada: 'Método de retirada',
    _HoradeCriação: 'Tiempo de creación',
    _Horadeexecução: 'Tiempo de ejecución',
    _NúmerodoPedido: 'Número de pedido',
    _Vocêtambém: 'También hay que apostar con eficacia',
    _VocêtambémRight: 'para retirar dinero!',
    _Vezes: 'Times',
    _Apostaválidanecessária: 'Se requiere una apuesta válida',
    _Adicionarponto: 'Añadir punto',
    _Completado: 'Completado',
    _fonte: 'fuente',
    _Saldo: 'Saldo',
    _Vocêprecisaapostar: 'Tienes que apostar',
    _sacardinheiro: 'retirar dinero',
    _Bonus: 'Bono',
    _Estataxade:
      'Esta tasa de tramitación≈C$ 0,00 (llegada estimadaC$ 1.111,00)',
    _Tudo: 'Todo',
    _Vejaasregrasparadetalhes: 'Consulte las normas para más detalles',
    _Ganharjuros: 'Ganar intereses',
    _Confirmarretirada: 'Confirmar la retirada',
    _TotaldeSaques: 'Total de retiradas',
    _EmitindoparaPIX: 'Emitiendo a',
    _AdicionarPIX: 'Añadir',
    _Confirmar: 'Confirme',
    _Verifique:
      'Compruebe cuidadosamente su nombre y número de tarjeta, de lo contrario no se le abonará.',
    _Contapararecebimento: 'Cuenta de ingresos',
    _Detalhesdatarefadeapostas: 'Detalles de la apuesta',
    _Tipodefonte: 'Tipo de letra',
    _ObterAdicionarpontos: 'Conseguir/Añadir puntos',
    _Exigirmultiplicadordeaposta: 'Requerir multiplicador de apuesta',
    _Apostaválidanecessária: 'Se requiere una apuesta válida',
    _Apostajáválida: 'Apuesta ya válida',
    _Vocêprecisaapostar: 'Tienes que apostar',
    _Statusdatarefa: 'Estado de la tarea',
    _TempodeConclusão: 'Tiempo de finalización',
    _Depósito: 'Depósito',
    _Adicionar: 'Añadir',
    _EsperandoRetirada: 'En espera de recogida',
    _RetiradaBemSucedida: 'Retirada con éxito',
    _RetiradaCancelada: 'Retirada cancelada',
    _Aguardandoapostas: 'A la espera de apuestas',
    _Têmemmão: 'Están a mano',
    _Completado: 'Completado',
    _Abandonado: 'Abandonado',
    _AdicionarConta: 'Añadir cuenta',
    _Anual: 'Anual',
    _Lobby: 'Vestíbulo'
  },
  subgame: {
    _Slots: 'Tragamonedas'
  },

  promote: {
    _MeuLink: 'Mi enlace',
    _MododeAgente: 'Modo Agente',
    _RededoAgente: 'Red de agentes',
    _Nœud: 'Diferencia de nivel infinita (nodo de día)',
    _Coletável: 'Coleccionable',
    _Subordinadosdiretos: 'Dirigir a los subordinados',
    _CódigodeConvite: 'Código de invitación',
    _Receber: 'Reciba',
    _Histórico: 'Historia',
    _CliqueparaSalvar: 'Haz clic para guardar',
    _Adicionarmembrosdiretos: 'Añadir miembros directos',
    _PrimeirosDepósitos: 'Primeros depósitos',
    _Depósitos: 'Depósitos',
    _Depósito: 'Depósito',
    _Desempenho: 'Rendimiento',
    _Comissão: 'Comisión',
    _ReportDataTitle: [
      'Datos del informe directo de hoy',
      'Datos de ayer del informe directo',
      'Datos del informe directo de esta semana',
      'Datos de informes directos de la semana pasada',
      'Datos de este mes para el informe directo',
      'Datos de informes directos del último mes'
    ],
    _Datasummary: 'Resumen de datos',
    _MeuTime: 'Mi equipo',
    _Desempenho: 'Rendimiento',
    _Comissão: 'Comisión',
    _Membros: 'Miembros',
    _MembrosDiretos: 'Miembros directos',
    _OutrosMembros: 'Otros diputados',
    _RendimentoTotal: 'Ingresos totales',
    _Rendimento: 'Ingresos',
    _DDireto: 'D. Directo',
    _DdosOutros: 'D. de otros',
    _ComissõesTotais: 'Total Comisiones',
    _MemberID: 'ID de miembro',
    _ApostasVálidas: 'Apuestas válidas',
    _RecargaDireta: 'Recarga directa',
    _Primeirarecargadireta: 'Primera recarga directa',
    _OutroDepósito: 'Otro depósito',
    _Outrasrecargasiniciais: 'Otras recargas iniciales',
    _DepósitoTotal: 'Depósito total',
    _Totaldejogadoresfazendoprimeirosdepósitos:
      'Número total de jugadores que realizan su primer depósito',
    _IDdeMembro: 'ID de miembro',
    _ComissãoDireta: 'Comisión directa',
    _OutraComissão: 'Otra Comisión',
    _SubordinadosDele: 'Sus subordinados',
    _Depósito: 'Depósito',
    _DatadeCadastro: 'Fecha de inscripción',
    _ApostasVálidas: 'Apuestas válidas',
    _Datadelogin: 'Fecha de inicio de sesión',
    _Atual: 'Actual',
    _Estado: 'Estado',
    _Númerodeinscritos: 'Número de solicitantes',
    _Apostasválidas: 'Apuestas válidas',
    _Apostaválidadireta: 'Apuesta directa válida',
    _VDdiretas: 'V/D directo',
    _Depósitos: 'Depósitos',
    _PrimeirosDepósitos: 'Primeros depósitos',
    _Depósito: 'Depósito',
    _ApostasVálidas: 'Apuestas válidas',
    _Ontem: 'Ayer',
    _Hoje: 'Hoy',
    _EstáSemana: 'Esta semana',
    _ÚltimaSemana: 'Última semana',
    _EsteMês: 'Este mes',
    _MêsPassado: 'Último mes',
    _DataLiquidação: 'Fecha de liquidación',
    _customerservice: 'atención al cliente',
    _Desempenhototal: 'Rendimiento total',
    _RetornodeComiss: 'Devolución de comisiones',
    _escalonada: 'Comisión escalonada',
    _contribuicomissão: 'contribuye comisión',
    _Contribuipara: 'Contribuye a',
    _Dediferenciais: 'Diferenciales',
    _Donível: 'El nivel',
    _Semdenível: 'Sin diferencia de nivel',
    _Umexemplo: 'Un ejemplo es el siguiente',
    _Comisde: 'En',
    _UmexemploSuponha:
      'Supongamos que las apuestas reales de 0 a 10.000 recibirán una comisión de 100 (es decir, el 1%) por cada 10.000, y las apuestas reales superiores a 10.000 recibirán una comisión de 300 por cada 10.000 (es decir, el 3%), A fue el primero en descubrir oportunidades de negocio en este sitio e inmediatamente desarrolló B1, B2 y B3. B1 desarrolló además a C1 y C2. B2 no desarrolló a ningún subordinado y B3 desarrolló al relativamente poderoso C3. El segundo día, la apuesta efectiva de B1 es de 500, la de B2 es de 3.000, la de B3 es de 2.000, la de C1 es de 1.000, la de C2 es de 2.000 y la de C3 llega a 20.000. ',
    _UmexemploEntseguinte:
      'Por lo tanto, el método para calcular el alquiler entre ellos es el siguiente',
    _Umexemplocontribui: 'contribuciones directas de',
    _semSubordinados: 'sin subordinados',
    _UmexemplodiretaMe: 'contribución directa de',
    _UmexemploAlcontribui:
      ' Además de las contribuciones de los subordinados directos B1, B2 y B3, la comisión de A también procede de las contribuciones de otros subordinados C1, C2 y C3, del siguiente modo',
    _Comissdiretade: 'Direct',
    _Outrascomissesde: 'Otros',
    _dascontribui: 'contribuciones',
    _Comisstotalde: 'Comisión total de',
    _diretoOutro: 'directo + otros',
    _Resumo: 'Resumen',
    _Equipedireta: 'Equipo directo',
    _EquipediretaDes:
      'se refiere a los subordinados desarrollados directamente por A, es decir, el primer nivel de relación con A, denominados colectivamente equipo directo. ',
    _Outrasequipes: 'Otros equipos',
    _OutrasequipesDes:
      'Se refiere a aquellos que son desarrollados por subordinados de A. Tienen una relación de segundo nivel con A o superior, es decir, subordinados de subordinados, y subordinados de subordinados... etc., denominados colectivamente otros equipos; como este modelo y agencia pueden desarrollar subordinados ilimitados, por conveniencia de la explicación, este artículo toma sólo la estructura de 2 niveles como ejemplo.',
    _Total: 'Total',
    _Vlidoouno: 'Válido o no',
    _menregistro: 'Hora de inscripción',
    _DetalhesMe_me: 'Detalles de la ampliación',
    _Lucroeperdademembro: 'Pérdidas y ganancias',
    _Resgatardesconto: 'Canjear descuento',
    _Detalhesdaaposta: 'Detalles de la apuesta',
    _Subordinadosde: 'Subordinados de',
    _Plataformadejogo: 'Plataforma de juego',
    _Nomedojogo: 'Nombre del juego',
    _ApostasVálidas: 'Apuestas válidas',
    _dosmembros: 'V/D de los miembros',
    _Normal: 'Normal',
    _Lock: 'Cerradura',
    _Totaldeapostas: 'Total de apuestas',
    _Comissrecebida: 'Comisión recibida',
    _TGServio: 'Servicio Telegram',
    _WSServio: 'Servicio WhatsApp ',
    _deAtividade: 'Nivel de actividad',
    _Lembreteimportante: 'Recordatorio importante',
    _Pontosdesorteatuais: 'Puntos de suerte actuales',
    _Vocaindaprecisaapostar: 'Todavía tienes que apostar',
    _paraobter: 'para obtener',
    _Pontosdesorte: 'Puntos de suerte',
    _RODAR: 'RUEDA',
    _RodaPrata: 'Rueda de plata',
    _RodaOuro: 'Rueda de Oro',
    _RodaDiamante: 'Rueda de diamante',
    _Perdasdeontem: 'Las pérdidas de ayer',
    _Bnusdesuportehoje: 'Bonificación de ayuda de hoy',
    _Perdasdeontem2: 'Perdas de la última semana',
    _Bnusdesuportehoje2: 'Subvenciones de esta semana',
    _Valordaperda: 'Valor de la pérdida',
    _PrmiosExtra: 'Premios extraordinarios',
    _recompensasMen_me: 'No hay recompensas que recibir por el momento',
    _Primeirodepsito: 'Primer depósito',
    _Recompensa: 'Recompensa',
    _Dispositivoatual: 'Dispositivo actual',
    _Aplicativo: 'Aplicación',
    _Versão: 'Versión',
    _Tipodeequipamento: 'Tipo de equipamiento',
    _Sistema: 'Sistema',
    _ÁreaIP: 'Área IP',
    _Horáriodelogin: 'Horas de inicio de sesión',
    _Outrosdispositivos: 'Otros dispositivos'
  },

  mine: {
    _RecuperaroSaldo: 'Recuperar el equilibrio',
    _Conta: 'Cuenta',
    _Apostas: 'Apuestas',
    _Relatório: 'Informe',
    _GestãoRetiradas: 'Gestión de las retiradas',
    _Convidar: 'Agente',
    _Dados: 'Datos',
    _Segurança: 'Seguridad',
    _Música: 'Música',
    _Idioma: 'Idioma',
    _FAQ: 'PREGUNTAS FRECUENTES',
    _BônusdeSugestão: 'Bonificación por sugerencias',
    _Façaloginnodispositivo: 'Iniciar sesión en el dispositivo',
    _Sobre: 'Acerca de',
    _Sair: 'Salida',
    _Suporte: 'Ayuda',
    _Mensagens: 'Mensajes',
    _Dados: 'Datos',
    _Confirmarsaída: 'Confirmar salida',
    _Cancelar: 'Cancelar',
    _Desejaterminarsessãodaconta: 'Desea desconectarse de su cuenta?',
    _Conta: 'Cuenta',
    _Lembrete: 'Recordatorio',
    _Saque: 'Retiro',
    _Depósito: 'Depósito',
    _Juros: 'Interés',
    _FundodePrevidência: 'Fondo de previsión',
    _Apostaparapromoção: 'Apostar por el ascenso',
    _Restantes: 'Resto',
    _Valorrestanteparaaposta: 'Importe que queda por apostar',
    _RemainingDepositAmount: 'Cantidad restante por Depósito',
    _DepositPromotion: 'Depósito para promoción',
    _SenhadeLogin: 'Contraseña',
    _Cashback: 'Cashback',
    _unlogin_tip1: 'Por favor, primeiro ',
    _unlogin_tip2: 'Inicie sesión ',
    _unlogin_tip3: 'O ',
    _unlogin_tip4: 'Regístrese',
    _function1: 'Interés',
    _function2: 'Mis registros',
    _function3: 'Gestión de la retirada',
    _function4: 'VIP',
    _function5: 'Promoción',
    _function6: 'Datos',
    _function7: 'Seguridad',
    _function8: 'Idioma',
    _function9: 'FAQ',
    _function10: 'Bonificación por recomendación',
    _function11: 'Inicia sesión en el dispositivo.',
    _function12: 'Salir'
  },

  Login: {
    _Login: 'Login',
    _Registro: 'Register',
    _Depósito: 'Depósito',
    _Saque: 'Retiro',
    _Juros: 'Interés',
    _RegistrodeDepósito: 'Depósito Registro',
    _Depósitoonline: 'Depósito en línea',
    _Expandir: 'Ampliar',
    _Fechar: 'Cerrar',
    _MínimoRechare: 'Mínimo ',
    _MáximoRechare: ', Máximo ',
    _Lembrete:
      "Recordatorio：Haz clic en 'Comprar saldo', selecciona la cantidad que necesitas, recarga para aumentar tus puntos!!",
    _RecarregueAgora: 'Recargar ahora',
    DepositeAgora: 'Depósito Agora',
    _RegistrodeDepósito: 'Depósito Registro',
    _Abraseuaplicativo:
      'Abra su aplicación de pago y escanee o copie y pegue el siguiente código QR para completar su compra;',
    _Estecódigo:
      'Este código QR sólo se puede pagar una vez. Si necesitas pagar de nuevo, vuelve a descargarlo;',
    _Apósopagamento:
      'Una vez que el pago se haya realizado correctamente, puedes volver al vestíbulo del juego y esperar a que se añadan los puntos.',
    _DepósitoTotal: 'Depósito total',
    _Pagamento: 'Pago',
    _Pendente: 'Pendiente',
    _Jápago: 'Recarga con éxito',
    _PedidoExpirado: 'Pedido caducado',
    _Tempoefetivo: 'Tiempo efectivo',
    _CopiarcódigoQR: 'Copiar código QR',
    _EndereçodocódigoQR: 'Dirección del código QR',
    _Statusdopedido: 'Estado del pedido',
    _RegistrosdeAuditoria: 'Registros de auditoría',
    _HoradeCriação: 'Tiempo de creación',
    _NúmerodoPedido: 'Número de pedido',
    _Númerodopedidodocomerciante: 'Número de pedido del comerciante',
    _Lembre: 'Recordar la contraseña de su cuenta',
    _Suporte: 'Número de teléfono móvil/cuenta de asistencia',
    _Suporteaocliente: 'Atención al cliente',
    _JogarGrátis: 'Ver demostración',
    _EsqueceuaSenha: 'Contraseña olvidada',
    _dengLuPa: 'Por favor, introduzca el número de móvil/cuenta',
    _Senha: 'Contraseña',
    _SuporteContaRegistro: 'Sólo admite AccountRegistration',
    _Registrodocódigodeverificação: 'Registro del código de verificación',
    _Cadastrodesenha: 'Registro de contraseña',
    _accAcrt:
      'La moneda determina los juegos de terceros y los métodos de pago y no puede cambiarse.',
    _Tenhomaisde: 'Tengo +18 años, he leído y acepto las Condiciones de uso',
    _Tenhomaisde2: 'He leído y estoy de acuerdo con la',
    _AcordodeUsuário: 'Acuerdo de usuario',
    _AcordodeUsuário2: 'Acuerdo de usuario',
    _Confirme: 'Confirme de nuevo la contraseña, la misma que la contraseña!',
    _DigiteoNúmerodoCelular: 'Introduzca el número de móvil',
    _VerificaçãodeID: 'Verificación de la identidad',
    _RedefiniçãodeSenha: 'Restablecer contraseña',
    _Terminar: 'Acabado',
    _ErroNo:
      'Error de formato de cuenta,4-16 caracteres, admite inglés/números',
    _caracteresMens:
      '6-16 caracteres, incluyendo al menos dos letras/números/símbolos',
    _vazioestar: 'Mobile NumberField no debe estar vacío',
    _Seguintes: 'Siguiente',
    _realName:
      'Complete el nombre real y hágalo conveniente para el retiro posterior!',
    newText1: 'Inicia sesión con WhatsApp para videollamar con mujeres reales',
    newText2: '¡Disfruta de más contenido emocionante!',
    newText3: 'Ingresa el número de teléfono de WhatsApp',
    newText4: 'Ingresa el código en tu teléfono',
    newText5: 'Vinculando cuenta de WhatsApp',
    newText6: 'Copiar a WhatsApp',
    newText7: 'El código de emparejamiento se ha copiado, pégalo en WhatsApp',
    newText8:
      'Presta atención a la ventana emergente de WhatsApp a continuación.',
    newText9: 'Código de verificación:',
    newText10: 'REINTENTAR',
    newText11: 'Ingresa tu número de teléfono',
    newText12: 'Ingresa un número de teléfono válido',
    newText13: 'Configurar contraseña',
    newText14: 'Escriba una contraseña',
    newText15: 'La contraseña no puede ser inferior a seis dígitos',
    newText16: 'La contraseña es demasiado simple',
    newText17: 'RETRIES MAXIMOS ACHIBIDOS',
    newText18:
      'Max intentos alcanzados. Por favor, vuelva a intentarlo más tarde.'
  },

  components: {
    _copySuccess: 'Copiado com sucesso',
    _Registradocomsucesso: 'Registrado con éxito',
    _Vamosjogaragora: 'Juguemos ahora',
    _CheckInDi: 'Día de facturación',
    _Resgatado: 'Rescatado',
    _Depósitoobrigatrio: 'Depósito obligatorio',
    _Apostaobrigatri: 'Apuesta obligatoria',
    _Entrar: 'Entre en',
    _Check_insconsecutivos: 'Controles consecutivos',
    _Falhanocheckin: 'Fallo de facturación',
    _Irparadepsito: 'Ir al depósito',
    _Topo: 'Top',
    _TOPO_1: 'TOP',
    _Encontre_nos: 'Encuéntranos',
    _LoginRpido: 'Inicio de sesión rápido',
    _GoogleLogin: 'Inicio de sesión en Google',
    _CanalOficial: 'Canal oficial',
    _Telegramoficial: 'Telegrama oficial',
    _Instagramoficial: 'Instagram oficial',
    _Siteoficial: 'Sitio web oficial',
    _DatadeInício: 'Fecha de inicio',
    _DatadeFim: 'Fecha final',
    _Confimar: 'Confirme',
    _Preencha: 'Rellene los datos correctamente: El CPF de la cuenta que',
    _normalmente: 'ha solicitado que este pago se abone normalmente',
    _Wrongamount: 'Cantidad incorrecta',
    _Introduzaoseunomereal: 'Introduzca su nombre real',
    _Strength: 'Fortaleza',
    _IntroduzadoCPF: 'Introduzca el número CPF de 11 dígitos',
    _paymentpage: 'Por favor espere, salte a la página de pago!',
    _Deptodo: 'Método de depósito',
    _Canalderecarga: 'Canal de recarga',
    _Bnusdeprimeirodepsito: 'Bonificación por primer depósito',
    _hojeNovamente: 'No lo vuelvas a mostrar hoy',
    _Ocultarpermanenfemente: 'Ocultar permanentemente',
    _Prosseguir: 'Continuar',
    _Total_deapostas: 'Total de apuestas durante el evento',
    _ValorSorteUtilizado: 'Valor de suerte utilizado',
    _Valordasorteexpirado: 'El sorteo ha expirado',
    _ValorSortedisponvel: 'Cantidad de suerte disponible',
    _Containsira: 'Introducir cuenta',
    _novamentefavor: 'Confirme de nuevo su contraseña',
    _Brasil55: 'Brasil（+55）',
    _Registrar: 'Regístrese en',
    _Registrovinculativo: 'Registro vinculante',
    _PorfavorinsiraConta: 'Introduzca la cuenta',
    _mboloscaracteres6_16:
      '6-16 caracteres, incluidos al menos dos letras /n/números/símbolos',
    _apenasM_Registro: 'Sólo admite la cuenta de registro',
    _CelularRegistroMe: 'Sólo admite el registro de números de móvil',
    _Verifiqueacordo: 'Compruebe primero el acuerdo de usuario',
    _vinculadoCPF: 'CPF no válido o vinculado',
    _digitenovamente: 'La cuenta no admite 6-12 dígitos puros, escriba de nuevo',
    _suporta_dr_55: ' admite 10-11 números de móvil, introdúzcalo de nuevo',
    _Esteonmerodo: 'Este es el número del',
    _Estaaconta: 'Este es el proyecto de ley',
    _SuporteapenasContaLogin: 'Sólo se admite la cuenta de inicio de sesión',
    _SuporteapenasdoCelularLogin:
      'Asistencia sólo Número de móvil Inicio de sesión',
    _DigiteoConta: 'Introduzca la cuenta',
    _Digite_Celular_e: 'Introducir número de móvil/cuenta',
    _celularSuporta: 'admite entre 10 y 11 números de teléfono móvil',
    _inglMbolos_men: '6-16 dígitos, inglés/números/símbolos',
    _novamenteConfirme:
      'Confirme de nuevo la contraseña, la misma que la contraseña!',
    _recebera: 'Usted recibirá',
    _evento: 'Bono del evento',
    _coletar: '(Recuerda recoger)',
    _Deppsito: 'Oferta de Depósito',
    _Participacao: 'Participación automática en las siguientes actividades'
  },
  RecuperaroSaldo: {
    _RecuperaroSaldo: 'Recuperar el equilibrio',
    _Saldoatual: 'Saldo actual',
    _Umcliquepararecuperar: 'Un clic para recuperar',
    _yaTeng:
      'Sólo puede recuperar el múltiplo entero del saldo (es decir, sin punto decimal)',
    _Tudos: 'Todos',
    _Pesquisadeplataforma: 'Búsqueda en la plataforma'
  },

  report: {
    _Conta: 'Cuenta',
    _Apostas: 'Apuestas',
    _Relatório: 'Informe',
    _Valorcumulativodaaposta: 'Importe acumulado de la apuesta',
    _TotaldeApostasVálidas: 'Total de apuestas válidas',
    _TotaldeV: 'Total V/D',
    _DepósitoTotal: 'Depósito total',
    _TotaldeSaques: 'Total de retiradas',
    _AcumuladoTotal: 'Total acumulado',
    _Saldo: 'Saldo',
    _ApostasVálidas: 'Apuestas válidas',
    _GanhosePerdas: 'Ganancias y pérdidas',
    _NúmerodaNota: 'Número de nota'
  },

  security: {
    _SenhadeSaque: 'Contraseña de retirada',
    _Paraase:
      'Para garantizar la seguridad de sus fondos, primero debe establecer una contraseña de retirada.',
    _Definasuasenhadesaque: 'Establezca su contraseña de retirada',
    _NovaSenhadeSaque: 'Nueva contraseña de retirada',
    _Nãomesmosounúmeroscontínuos: 'No pueden ser 6 o números continuos',
    _Atenção:
      'Nota: La contraseña de retirada protege sus fondos y es extremadamente importante. Manténgala en secreto para evitar cualquier pérdida financiera.',
    _Confirmar: 'Confirme',
    _Senhaincorreta: 'Contraseña incorrecta, escriba de nuevo!',
    _Confirmenova: 'Confirme la nueva contraseña de retirada',
    _AlterarSenhadeSaque: 'Cambiar la contraseña de retirada'
  },
  _homeTile_tab: {
    _meCmeTen: 'La cuenta pix no puede estar vacía',
    _primeiroprecisa: 'Primero debe configurar la contraseña de retiro',
    _VerifiqueAntiga: 'Compruebe la contraseña de inicio de sesión antigua',
    _Convideumapessoa: 'Recomienda amigos para abrir el Cofre del Premio',
    _CupomRecompensas: 'Cupón de recompensas',
    _Centrodemensagens: 'Centro de información',
    _Girodasorte: 'Rotación afortunada',
    _DetalhesdoDepsito: 'Detalles del depósito',
    _campodeNomereal: 'El campo de nombre real no puede estar vacío',
    _Descride: '...... Descripción',
    _Explicao: 'Explicación',
    _Resumodasregras: 'Resumen de las normas',
    _importaquando:
      'No importa cuándo entres, de quién vengas, no importa en qué nivel estés, tus ingresos no se verán afectados y ya no sufrirás las pérdidas de los subordinados de los demás. El desarrollo no está limitado. Este es un modelo de agencia absolutamente justo y justo, y nadie siempre caerá porque llega tarde.',
    _tenhaEmbora:
      'Aunque el B3 se unió relativamente tarde y perteneció a a, su subordinado C3 es muy fuerte, con un rendimiento directo de 20.000, lo que permite al B3 disfrutar directamente de mayores Comisiones. El porcentaje es del 3%. ',
    _preguiBeneficiar:
      'B2 puede ser perezoso y no se beneficiará si no forma subordinados.',
    _menTenMensg:
      'B1 tiene subordinados C1 y C2. Debido a que el rendimiento directo es de 3.000, el índice de descuento correspondiente es del 1%.',
    _contribuiComiss: 'A la cuota es 0.',
    _diretoDesempenho:
      'El rendimiento directo de a es de 5.500 y el otro de 20.000 (debido a la Potencia c3). El resultado total es de 28.500 y la Comisión correspondiente a la tasa es del 3%. Debido a que el rendimiento total de B1 es de 3.000, el descuento es solo del 1%, mientras que el rendimiento total de a es de 28.500 y la tasa de descuento es del 3%, habrá una diferencia de descuento entre A y b1. La diferencia es: 3% - 1% = 2%, esta diferencia es la parte de la contribución de C1 y C2 a a, por lo que C1 y C2 aportan a: (1000 + 2000) * 2% = 60, no hay diferencia extrema entre A y b3, por lo que C3',
    _Emandamento: 'Persistente',
    _ltimosDias2: 'Los últimos dos meses',
    _ltimosDias3: 'Los últimos tres meses',
    _ltimosDias7: 'Los últimos 7 días',
    _ltimosDias15: 'Los últimos 15 días',
    _ltimosDias30: 'Los últimos 30 días',
    _Quasedias60: 'Casi 60 días',
    _TodososStatus: 'Todos los Estados',
    _NoLiquidado: 'No liquidado',
    _Liquidado: 'Estable',
    _Pedidocancelado: 'El pedido ha sido cancelado',
    _TodososTipos: 'Todos los tipos',
    _TrocadeFundos: 'Intercambio de fondos',
    _RecargadeMembro: 'Recarga de miembros',
    _SaquedeMembro: 'Sorteo de miembros',
    _LiquidaodoComerciante: 'Liquidación de comerciantes',
    _CorreodeFundo: 'Corrección de fondo',
    _TaxadeRebate: 'Tasa de reembolso',
    _Bonus: 'Bono',
    _Distribudo: 'Distribuido'
  },
  noticeInfo: {
    _menCmensEscaneie:
      'Escanee el Código QR o abra el enlace de invitación en el navegador. Descargue el juego y registre, y luego use su Código QR único o enlace de invitación para invitar a otros.',
    _menCmensClique:
      'Haga clic en "promoción" en la Sala para ingresar a la página de promoción. Su único código QR y enlace promocional se pueden encontrar en la parte inferior. Guarde la imagen y comparta.',
    _menCmensrendimento:
      'La tasa de rendimiento se refiere a las apuestas efectivas de los jugadores en el juego. Por ejemplo, si promoves a un jugador que apuesta 1000 veces, equivale a 1000 contribuciones de rendimiento.',
    _menCmenscliqueverificar:
      'Vaya a "promociones" y haga clic en "rendimiento" para comprobar su nivel de rendimiento. También puede hacer clic en "mi comisión" para ver su historial de comisiones y liquidación.  r?',
    _menCmensVoce:
      'Puede retirar dinero introduciendo los detalles correctos de la tarjeta bancaria y haciendo clic en "retirar dinero".',
    _menCmensApos:
      'Después de la recarga, el jugador debe apostar en el juego. La transacción de retiro solo se puede completar después de revisar esta solicitud.',
    _menCmensEscaneie_title: 'cómo convertirse en agente?',
    _menCmensClique_title: 'dónde puedo compartir el Código de invitación?',
    _menCmensrendimento_title: 'cómo se calcula el rendimiento?',
    _menCmenscliqueverificar_title:
      ' dónde puedo ver mi nivel de rendimiento y comisión?',
    _menCmensVoce_title: ' cómo retirar dinero?',
    _menCmensApos_title: ' cuáles son los requisitos para recargar y retirar?',
    _Outrasperguntas: 'Otros problemas',
    _PerguntasSobrecoleao: 'Problemas de recogida',
    _Perguntasderecarga: 'Problema de recarga',
    _Perguntasdojogo: 'Problemas de juego',
    _SistemadeMsica: 'Sistema musical',
    _MinhasMsicas: 'Mi canción',
    _Ciclo: 'Ciclo',
    _Baixado: 'Descargado'
  },
  common: {
    // ......
    title1: 'Juego especial',
    mineText1: 'Inicia sesión para ganar bonos',
    mineText2: 'Información de la pantalla estándar',
    mineText3: 'Check In diario',
    mineText4:
      ' ¡Inicia sesión todos los días y disfruta de innumerables presentes!',
    mineText5: 'Más eventos',
    mineText6:
      'Por favor, Descargar y iniciar sesión en la APP、Iniciar sesión en la página web para celular recoger-lo',
    mineText7: 'Función rápida'
  },
  index: {
    // ......
  }
};
